export const A_BUILD_CHANGED = "build";
